import React from 'react'
import { PATHS } from '../../../Config/Routing/paths'
import { getWeekNumberAndYear } from '../../../shared/libraries/utils/date'

import CampaignsIcon from '../../../Assets/Images/icons/campaigns'
import CitiesIcon from '../../../Assets/Images/icons/cities'
import { MISSION_ENUM_TYPES } from '../../../shared/constants'

/**
 * Generates breadcrumbs for the RosterView page that can be consumed by <BreadcrumbsRenderer />
 *
 * @param {object} param.mission Mission's data
 * @param {object} param.match Router's prop
 * @param {boolean} param.fromCityScreen Indicates whether user come to this page from the city screen
 * @param {object} param.city Mission's city
 *
 * @returns {array} Items that can be consumed by <BreadcrumbsRenderer />
 */
export const getBreadcrumbs = ({ mission, city, match, fromCityScreen }) => {
  const {
    main: { dashboard: root },
    dashboard: { campaigns },
  } = PATHS
  const localDateTime = mission.dateTime
  const { weekNumber, year } = getWeekNumberAndYear(new Date(localDateTime))
  const rosterId = year + '-' + weekNumber

  const hasRoster = mission.type === MISSION_ENUM_TYPES.HANDTOHAND

  const typeSpecificBC = hasRoster
    ? [
        {
          title: city.name,
          pathname:
            PATHS.main.dashboard +
            PATHS.dashboard.cities +
            `/${city.id}/roster`,
        },
        {
          title: 'View a Roster',
          pathname: `${root}${campaigns}/${mission.campaign.id}/city-plans/${
            mission.cityPlanId
          }/rosters/${rosterId}`,
        },
      ]
    : [
        {
          title: `${city.name} City Plan`,
          pathname: `${root}${campaigns}/${mission.campaign.id}/city-plans/${
            mission.cityPlanId
          }/missions`,
        },
      ]

  if (fromCityScreen) {
    return {
      icon: <CitiesIcon style={{ width: 24 }} />,
      items: [
        {
          title: 'Cities',
          pathname: PATHS.main.dashboard + PATHS.dashboard.cities,
        },
        ...typeSpecificBC,
        { title: 'Mission', pathname: match.url },
      ],
    }
  }

  return {
    icon: <CampaignsIcon style={{ width: 16 }} />,
    items: [
      {
        title: 'Campaigns',
        pathname: `${root}${campaigns}`,
      },
      {
        title: mission.campaign.name,
        pathname: `${root}${campaigns}/${mission.campaign.id}/city-plans`,
      },
      {
        title: hasRoster ? 'View a Roster' : 'View a City Plan',
        pathname: `${root}${campaigns}/${mission.campaign.id}/city-plans/${
          mission.cityPlanId
        }${hasRoster ? '/rosters/' + rosterId : '/missions'}`,
      },

      {
        title: 'Mission',
        pathname:
          `${root}${campaigns}/${mission.campaign.id}/city-plans` + match.url,
      },
    ],
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Mission/Header/util.js